<template>
  <div class="mt-4">
    <filter-bar @set-new-report-params="setNewReportParams"></filter-bar>
    <div class="md-layout">
      <div class="md-layout-item content">
        <report-empty-state
          v-if="hasNoReportView"
          :title="$t('score_report.student.empty_state_title')"
          :desc="$t('score_report.student.empty_state_desc')"
        ></report-empty-state>
        <template v-else>
          <student-information></student-information>
          <course-grades-table
            :course-grades="reportData.courseGrades"
          ></course-grades-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FilterBar from "./FilterBar.vue";
import StudentInformation from "./Information.vue";
import CourseGradesTable from "./CourseGradesTable.vue";
import ReportEmptyState from "@/pages/Report/Components/EmptyState.vue";
import { service_paths, service_names } from "@/constants/Services";
import { initLoader } from "@/helpers/utils";

export default {
  components: {
    FilterBar,
    StudentInformation,
    CourseGradesTable,
    ReportEmptyState
  },
  data() {
    return {
      path: service_paths.reports,
      reportParams: {
        selectedStudent: null,
        selectedProgram: null
      },
      reportData: {
        gpaSum: null,
        gradeLetter: null,
        creditsSum: null,
        courseGrades: null
      }
    };
  },
  computed: {
    hasNoReportView() {
      const hasNoReportData = Object.values(this.reportData).every(
        value => !value
      );
      return hasNoReportData;
      // return false;
    },
    baseReportQueryObj() {
      const student_id = this.reportParams.selectedStudent?.id;
      const program_id = this.reportParams.selectedProgram?.id;

      return {
        student_id,
        program_id
      };
    }
  },
  methods: {
    setNewReportParams(reportParams) {
      this.$set(
        this.reportParams,
        "selectedStudent",
        reportParams.selectedStudent
      );
      this.$set(
        this.reportParams,
        "selectedProgram",
        reportParams.selectedProgram
      );
    },
    fetchStudentGradeLetter(baseReportQueryObj) {
      return this.$axios
        .get(
          `${this.path}/score/grade-letter`,
          baseReportQueryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.gradeLetter = data;
        });
    },
    fetchStudentGPASum(baseReportQueryObj) {
      return this.$axios
        .get(
          `${this.path}/gpa/summary`,
          baseReportQueryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.gpaSum = data;
        });
    },
    fetchStudentCourseGrade(baseReportQueryObj) {
      return this.$axios
        .get(
          `${this.path}/score/course-grade`,
          baseReportQueryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.courseGrades = data;
        });
    },
    fetchStudentCreditSums() {
      const uuid = this.reportParams.selectedStudent?.uuid;
      const program_id = this.reportParams.selectedProgram?.id;

      return this.$axios
        .get(
          `${service_names.school}/user-academic-plan/${uuid}/${program_id}`,
          {},
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.creditsSum = this.getCreditSumsFrom(data);
        });
    },

    getCreditSumsFrom(resData) {
      if (!resData) return [];

      const { list, total } = resData;

      if (!list || !total) return [];

      const avgRow = {
        ...total,
        name: this.$t("common.total"),
        isSumRow: true
      };
      return [...list, avgRow];
    }
  },
  watch: {
    baseReportQueryObj: {
      deep: true,
      handler: function(newBaseReportQueryObj) {
        const loader = initLoader();
        Promise.all([
          this.fetchStudentGradeLetter(newBaseReportQueryObj),
          this.fetchStudentGPASum(newBaseReportQueryObj),
          this.fetchStudentCourseGrade(newBaseReportQueryObj),
          this.fetchStudentCreditSums()
        ]).finally(() => loader.hide());
      }
    }
  },
  provide() {
    return {
      reportParams: this.reportParams,
      reportData: this.reportData
    };
  }
};
</script>

<style lang="scss" scoped>
thead tr * {
  font-weight: 600 !important;
}
</style>
